module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_question-0a80f1d8ab6761c2ce5a7d82a37f003e.svg";